import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { BlDetails, ExportBoats } from 'src/app/interfaces/bl.interfaces';
import { CabotageBatch } from 'src/app/interfaces/cabotageBatches.interfaces';
import { BatchesAvailableTransfer, ExportOutput, ExportOutputType } from 'src/app/interfaces/exportationBatches.interfaces';
import { LocationInterface, NationalPorts, Origen, SalidaCatalogo, TranportLine } from 'src/app/interfaces/lotes.interfaces';
import { OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
import { TonsPerYard } from 'src/app/interfaces/tons-per-yard.interfaces';

/**
 * Componente de página que gestiona el registro de salidas de un lote de cabotaje,
 * cargando los catálogos necesarios y alternando entre los distintos tipos de salida.
 */
@Component({
  selector: 'app-cabotaje-lote-salida',
  templateUrl: './cabotaje-lote-salida.component.html',
})
export class CabotajeLoteSalidaComponent implements OnInit {
  tipoSalida: string = '1';
  loader: boolean = true;
  batchValue: number = 0;
  nationalPorts: NationalPorts[] = [];
  locations: LocationInterface[] = [];
  amountsPerYardList: TonsPerYard[] = [];
  outputTypes: ExportOutputType[] = [];
  boats: any[] = [];
  cabotageBatch: CabotageBatch[] = [];
  anexos: boolean = false;
  batchesAvailableTransfer: BatchesAvailableTransfer[] = [];
  transportType: SalidaCatalogo[] = [];
  unitType: SalidaCatalogo[] = [];
  listTransportLine: TranportLine[] = [];
  originsTicket: OriginTicket[] = [];
  outputs: ExportOutput[] = [];
  overlayError: boolean = false;
  operation_number: number = 0;
  blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
    remaining_tonnage:    0,
    output_total_tonnage: 0,
    operation_type:       '',
  };

  constructor(
    private router: Router,
    private loteService: LoteService,
    private loteCabotajeService: LoteCabotajeService,
    private amountsPerYardSvc: TonsPerYardService,
    private blService: BlService,
    private scaleTicketSvc: ScaleTicketService
  ) { }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.batchValue = Number(parts[parts.length - 1]);
    if (this.router.url.includes('ship-list')) {
      const currentUrl = this.router.url;
      const match = currentUrl.match(/\/ship-list\/(\d+)/);
      if (match) {
        this.operation_number = Number(match[1]);
      } else {
        this.loader = false;
        this.overlayError = true;
      }

      this.blService.getBlId(this.operation_number)
      .subscribe({
        next: (bldetails) => {
          if (!Array.isArray(bldetails) || !bldetails.length) {
            this.loader = false;
            this.overlayError = true;
            return;
          }
          this.blDetails = bldetails[0];
          this.getDataForOutputs(true);
        },
        error: (e) => {
          this.loader = false;
          this.overlayError = true;
        },
      });
    } else {
      this.getDataForOutputs(false);
    }
  }

  /**
   * Carga en paralelo los catálogos y datos requeridos para el registro de salidas del lote.
   * @param importCabotage - Indica si el flujo corresponde a un cabotaje de importación por barco.
   */
  getDataForOutputs(importCabotage: boolean) {
    forkJoin([
      this.loteService.getNationalPorts(),
      this.loteService.getExportOutputTypes(),
      this.getboats(importCabotage),
      this.loteCabotajeService.getCabotageBatch(this.batchValue),
      this.loteCabotajeService.getBatchesAvailableTransfer(this.batchValue),
      this.loteService.getTipoTransporte(),
      this.loteService.getTipoUnidad(),
      this.loteService.getListTransportLine(),
      this.scaleTicketSvc.getOriginsTicket(),
      this.loteCabotajeService.getListByBatchCabotageOutput(this.batchValue),
      this.loteService.getLocations(),
      this.amountsPerYardSvc.getTonsPerYardList(3, Number(this.batchValue))
    ]).subscribe({
      next: ([
        nationalPorts,
        outputTypes,
        boats,
        batch,
        batchesAvailableTransfer,
        transportType,
        unitType,
        listTransportLine,
        originsTicket,
        outputs,
        locations,
        amountsPerYardList
      ]) => {
        this.cabotageBatch = batch;
        const isExportCabotage = !this.router.url.includes('ship-list')
        if (!this.cabotageBatch[0].keys_files?.length && isExportCabotage) {
          this.anexos = true;
          setTimeout(() => {
            this.anexos = false;
          }, 4000);
        }
        outputTypes = this.filterCabotageOutputs(outputTypes);
        this.nationalPorts = this.sortArray<NationalPorts>(nationalPorts, 'description');
        this.outputTypes = [...outputTypes];
        this.boats = [...boats];
        this.batchesAvailableTransfer = this.sortArray<BatchesAvailableTransfer>(batchesAvailableTransfer, 'id');
        this.transportType = this.sortArray<SalidaCatalogo>(transportType.filter( t => t.id !== 2), 'description');
        this.unitType = this.sortArray<SalidaCatalogo>(unitType, 'description');
        this.listTransportLine = this.sortArray<TranportLine>(listTransportLine, 'description');
        this.originsTicket = this.sortArray<OriginTicket>(originsTicket, 'description');
        this.locations = this.sortArray<LocationInterface>(locations, 'description');
        this.amountsPerYardList = [...amountsPerYardList];
        this.outputs = [...outputs.sort((a, b) => {
          if (a.id && b.id) {
            return b.id - a.id;
          } else {
            return 0;
          }
        })];
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
  }

  /**
   * Obtiene la lista de embarcaciones según el contexto del flujo.
   * @param importCabotage - Indica si se debe usar la embarcación del BL de importación o consultar el catálogo.
   * @returns Un observable con la lista de embarcaciones.
   */
  getboats(importCabotage: boolean) {
    if (importCabotage) {
      const boats: ExportBoats[] = [
        {
          boats_number: this.blDetails.operation_number,
          boats_name: this.blDetails.boats_name,
          date: new Date().toISOString()
        }
      ]
      return of(boats)
    }
    return this.scaleTicketSvc.getBoatsByModule(3)
  }

  /**
   * Filtra los tipos de salida no aplicables al contexto actual del cabotaje.
   * @param outputTypes - Lista de tipos de salida a filtrar.
   * @returns La lista de tipos de salida válidos para el contexto.
   */
  filterCabotageOutputs(outputTypes: ExportOutputType[]): ExportOutputType[] {
    const outputIdInvalideList = [4];
    if (this.router.url.includes('ship-list'))
      outputIdInvalideList.push(2)
    return outputTypes.filter( output => !outputIdInvalideList.includes(output.id) );
  }

  /**
   * Actualiza el tipo de salida seleccionado.
   * @param tipo - Identificador del tipo de salida seleccionado.
   */
  cambiarSalida(tipo: string) {
    this.tipoSalida = tipo;
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }
}
